import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  saveLoading: false,
  disciplinaryActionLength: 0,
  disciplinaryAction: [],
  disciplinaryActionError: "",
  formError: "",
};

export default function DisciplinaryReasonReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_DISCIPLINARY_ACTION:
      return { ...state, loading: action.payload };
    case actions.SAVE_LOADING_DISCIPLINARY_ACTION:
      return { ...state, saveLoading: action.payload };
    case actions.GET_DISCIPLINARY_ACTION:
      return {
        ...state,
        disciplinaryAction: action.payload.disciplinaryAction,
        disciplinaryActionLength: action.payload.disciplinaryActionLength,
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.DISCIPLINARY_ACTION_FAIL:
      return { ...state, disciplinaryActionError: action.payload };
    default:
      return state;
  }
}
